export function parseBackendData<T>(data: T): T {
  if (typeof data === 'string' && data === 'unknown') {
    return undefined as unknown as T; // Convert "unknown" string to TypeScript unknown type
  }
  if (Array.isArray(data)) {
    return data.map(parseBackendData) as T;
  }
  if (data && typeof data === 'object') {
    return Object.fromEntries(
      Object.entries(data).map(([key, value]) => [key, parseBackendData(value)])
    ) as T;
  }
  return data;
}
